import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

export default function ConfirmDelete({ message, onConfirm, onCancel, elementNameToDelete, confirmLabel = 'Elimina' }) {
    return (
        <div className="bg-white rounded-lg shadow-lg w-full max-w-sm p-6 mx-4">
            <div className="flex flex-col items-center text-center space-y-4">
                {/* <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full">
                    <FaExclamationTriangle className="text-red-600 w-6 h-6" aria-hidden="true" />
                </div> */}
                <div className='flex flex-col gap-4'>
                    <p className="text-gray-800 text-lg font-semibold">{elementNameToDelete}</p>
                    <p className="text-gray-800 text-base">{message}</p>
                </div>


                <div className="flex justify-between space-x-3 w-full pt-4 border-t border-gray-200">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}